import Geeth from "../../images/Geeth-24.jpg";
export const homeObjOne = {
  id: "aboutme",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "About Me",
  headline: "I am a senior at Coppell High School",
  description:
    " I am a 17-year-old who likes to code, make music, and take pictures to express my creativity to the world. I started developing applications and websites in 2018. Over the years, I gained experience using modern programming languages like Swift, JavaScript, and Python. I  made an iOS app that fixed some people's problems and released it for free on the AppStore. I initially used HTML/CSS to make my websites, but recently I picked up  React.js to save some time reusing components and creating a smoother flow. I always had music and photography as my side gigs to work with people. I love helping people. I started taking photos for events professionally in 2021 for my friends and relatives.  ",
  description2: " Scroll down to see some of my projects.",
  buttonLabel: "Learn More",
  imgStart: true,
  img: Geeth,
  alt: "Geeth",
  dark: true,
  primary: true,
  darkText: false,
};
